import { render } from "./PageDialog.vue?vue&type=template&id=5f5231d5&scoped=true"
import script from "./PageDialog.vue?vue&type=script&lang=js"
export * from "./PageDialog.vue?vue&type=script&lang=js"

import "./PageDialog.vue?vue&type=style&index=0&id=5f5231d5&scoped=true&lang=less"

import exportComponent from "../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f5231d5"]])

export default __exports__